/**
 * Created by roman.kupin on 1/31/2018.
 */


export default class Parse {

    static bool(source): boolean {
        return source === true || source == "1" || source === "true";
    }

    static boolOrDefault(source, defaultValue): boolean {
        if (typeof (source) !== "undefined" && source != null)
            return source === true || source == "1" || source === "true";
        return defaultValue;
    }

    static int(source): number {
        const parsed = parseInt(source, 10);
        if (isNaN(parsed)) throw `${source} is not a number`;
        return parsed;
    }

    static intOrDefault(source, defaultValue): number {
        const parsed = parseInt(source, 10);
        return isNaN(parsed) ? defaultValue || 0 : parsed;
    }

    static float(source): number {
        const parsed = parseFloat(source);
        if (isNaN(parsed)) throw `${source} is not a number`;
        return parsed;
    }

    static floatOrDefault(source, defaultValue): number {
        const parsed = parseFloat(source);
        return isNaN(parsed) ? defaultValue || 0 : parsed;
    }

    static arrayOrDefault(array) {
        if (!array) return [];
        if (Array.isArray(array)) return array;
        if (Array.isArray(array.item)) return array.item;
        if (Array.isArray(array.datum)) return array.datum;
        return [array];
    };
}

